var map = {
	"./art-center-2.jpg": 191,
	"./art-center-3.jpg": 192,
	"./art-center.jpg": 193,
	"./btn-back.png": 69,
	"./fu-shin-street.jpg": 194,
	"./green-hub.jpg": 195,
	"./old-hostel.jpg": 196,
	"./railway-museum.jpg": 197,
	"./sam-man-tsai.jpg": 198,
	"./tai-po-geoheritage-centre.jpg": 199,
	"./the-lane-square.jpg": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;